import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper';
import PageNotFoundCommon from '../components/pages/PageNotFound';
import { apiGet } from '../modules/api';

const PageNotFoundComponent = props => {
  const desktopProps = { ...{ isDesktop: true }, ...props };
  return (
    <Fragment>
      <AppWrapper
        desktopComp={<PageNotFoundCommon {...desktopProps} />}
        mobileComp={<PageNotFoundCommon {...props} />}
      />
    </Fragment>
  );
};

PageNotFoundComponent.getInitialProps = ({ store, req, res }) => {
  if (req) {
    const url = req.url || null;
    req.datadog.increment('consumer_app.page_not_found', url ? [url] : []);
  }
  return store.dispatch(apiGet('api/home', req, res));
};

const mapStateToProps = ({
  api: { authComponent, basePath, marketingCheckbox, path, privacyCheckbox, s3BasePath, status }
}) => ({
  authComponent,
  basePath,
  marketingCheckbox,
  path,
  privacyCheckbox,
  s3BasePath,
  status
});

const PageNotFound = connect(mapStateToProps)(PageNotFoundComponent);
export default PageNotFound;
